module.exports = __webpack_public_path__ + "static/media/pfp2.45541e02.png";